module.exports = __webpack_public_path__ + "static/media/filter.4e55cb1e.jpg";